import React, { useState } from "react";
import { db, collection, addDoc } from "./Firebase"; // Ensure Firebase is configured

const ContactUs = () => {
  const [formData, setFormData] = useState({ name: "", email: "", message: "" });
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.name || !formData.email || !formData.message) {
      setErrorMessage("Please fill out all fields.");
      return;
    }

    setErrorMessage("");
    setSuccessMessage("Thank you for reaching out! We will get back to you soon.");

    try {
      const docRef = await addDoc(collection(db, "Query"), {
        ...formData,
        createdAt: new Date().toISOString(),
      });
      console.log("Document written with ID:", docRef.id);
      setFormData({ name: "", email: "", message: "" });
    } catch (err) {
      console.error("Error adding document:", err);
      setErrorMessage("There was an error. Please try again later.");
    }
  };

  return (
    <div className="contact-container">
      <header className="contact-header">
        <div className="overlay" />
        <h1 className="contact-title">Contact Us</h1>
      </header>

      <div className="contact-body">
        <div className="contact-info">
          <iframe
            title="map"
            src="https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d1309.1812757603948!2d74.94161628805217!3d30.22000190706265!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e0!3m2!1sen!2sin!4v1750424536373!5m2!1sen!2sin"
            width="100%"
            height="300"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
          ></iframe>
          <div className="info-block">
            <h3>Meet Us</h3>
            <p>📞 +91 9041429065</p>
            <p>📧 karanksxxx@gmail.com</p>
            <p>Ganesh Nagar ,Bathinda,Punjab,India</p>
          </div>
        </div>

        <div className="contact-form">
          <h3>Contact</h3>
          {errorMessage && <div className="alert error">{errorMessage}</div>}
          {successMessage && <div className="alert success">{successMessage}</div>}

          <form onSubmit={handleSubmit}>
            <input
              type="text"
              name="name"
              placeholder="Name"
              value={formData.name}
              onChange={handleInputChange}
              required
            />
            <input
              type="email"
              name="email"
              placeholder="Email"
              value={formData.email}
              onChange={handleInputChange}
              required
            />
            <textarea
              name="message"
              placeholder="Message"
              rows="4"
              value={formData.message}
              onChange={handleInputChange}
              required
            />
            <a href="mailto:karanksxxx@gmail.com" className="btn ">
  <button type="button">Send</button>
</a>
          </form>
        </div>
      </div>

      {/* Internal Styling */}
      <style jsx>{`
        .contact-container {
          font-family: 'Segoe UI', sans-serif;
          color: #333;
        }

        .contact-header {
          position: relative;
          background-image: url('https://images.unsplash.com/photo-1496181133206-80ce9b88a853');
          background-size: cover;
          background-position: center;
          height: 300px;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .overlay {
          position: absolute;
          top: 0; left: 0;
          width: 100%; height: 100%;
          background-color: rgba(0, 0, 0, 0.5);
        }

        .contact-title {
          position: relative;
          color: white;
          font-size: 3rem;
          font-weight: bold;
          z-index: 1;
        }

        .contact-body {
          display: flex;
          flex-wrap: wrap;
          justify-content: space-between;
          padding: 40px 10%;
          background-color: #f2f2f2;
        }

        .contact-info, .contact-form {
          background: white;
          border-radius: 10px;
          box-shadow: 0 5px 20px rgba(0,0,0,0.1);
          flex: 1 1 45%;
          margin: 10px;
          padding: 20px;
        }

        .info-block h3, .contact-form h3 {
          margin-bottom: 15px;
          color: #444;
        }

        .info-block p {
          margin: 5px 0;
          font-size: 16px;
        }

        .contact-form form {
          display: flex;
          flex-direction: column;
        }

        .contact-form input, .contact-form textarea {
          margin-bottom: 15px;
          padding: 12px;
          font-size: 16px;
          border-radius: 6px;
          border: 1px solid #ccc;
        }

        .contact-form button {
          background: linear-gradient(to right, #007bff, #00c6ff);
          color: white;
          padding: 12px;
          font-size: 16px;
          border: none;
          border-radius: 6px;
          cursor: pointer;
          transition: background 0.3s ease;
        }

        .contact-form button:hover {
          background: linear-gradient(to right, #0056b3, #0099cc);
        }

        .alert {
          margin-bottom: 15px;
          padding: 10px;
          border-radius: 5px;
          font-size: 14px;
        }

        .alert.error {
          background-color: #ffdddd;
          color: #a00;
        }

        .alert.success {
          background-color: #ddffdd;
          color: #070;
        }

        @media (max-width: 768px) {
          .contact-body {
            flex-direction: column;
            padding: 20px;
          }

          .contact-info, .contact-form {
            flex: 1 1 100%;
            margin: 10px 0;
          }

          .contact-title {
            font-size: 2rem;
          }
        }
      `}</style>
    </div>
  );
};

export default ContactUs;
